import {Injectable} from '@angular/core';
import {HttpObservable, HttpWrapper} from '../../common/http-helpers/http.wrapper';

@Injectable({
  providedIn: 'root'
})
export class PatientAccountPreferencesProxy {

  constructor(private httpWrapper: HttpWrapper) { }

  public setDefaultAccountLanguage(languageKey: number): HttpObservable<void> {
    return this.httpWrapper.post('PatientPortalAccountPreferences', 'SetDefaultAccountLanguage', languageKey);
  }
}
